import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=f75d2aba&"
import script from "./collapse.vue?vue&type=script&lang=ts&"
export * from "./collapse.vue?vue&type=script&lang=ts&"
import style0 from "./collapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports